var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page',{attrs:{"title":"兑换结果"}},[_c('x-result',{attrs:{"title":"兑换成功","message":_vm.messageObj[_vm.sourceType],"confirm-text":"查看订单","guess-resource-position-id":"8aaa92be7b66c738017b779b320000c4","confirm-track":{
      name: '支付成功-查看订单',
      id: 'bf9c697c-a19a-49d4-9adf-68e0ea9307ff',
    }},on:{"confirm":_vm.handleConfirmClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }